import * as React from "react";

function SvgAdobeAnalytics(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="1em"
      height="1em"
      viewBox="0 0 95 95.173"
      {...{ ...props, ref }}
    >
      <path opacity={0.2} d="M0 0h97.562v95.173H0z" />
      <path opacity={0.2} d="M1.938 0H99.5v95.173H1.938z" />
      <defs>
        <path id="AdobeAnalytics_svg__a" d="M1.938 0h95.625v93.235H1.938z" />
      </defs>
      <clipPath id="AdobeAnalytics_svg__b">
        <use xlinkHref="#AdobeAnalytics_svg__a" overflow="visible" />
      </clipPath>
      <radialGradient
        id="AdobeAnalytics_svg__c"
        cx={-796.145}
        cy={307.263}
        r={0.969}
        gradientTransform="matrix(142.3137 0 0 -142.3137 113355.273 43721.031)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={0.22} stopColor="#fff" />
        <stop offset={1} stopColor="#d9d9d8" />
      </radialGradient>
      <path
        clipPath="url(#AdobeAnalytics_svg__b)"
        fill="url(#AdobeAnalytics_svg__c)"
        d="M1.938 0h95.625v93.235H1.938z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#80C242"
        d="M47.902 11.157c-19.366 0-35.063 15.698-35.063 35.063s15.696 35.063 35.063 35.063S82.965 65.585 82.965 46.22 67.268 11.157 47.902 11.157m0 2.578c17.912 0 32.487 14.574 32.487 32.485 0 17.913-14.574 32.485-32.487 32.485S15.416 64.132 15.416 46.219c0-17.91 14.574-32.484 32.486-32.484"
      />
      <path
        fill="#1E311E"
        d="M39.336 47.016H35.75V70.64c1.1.553 2.411 1.036 3.586 1.434V47.016zm6.773-1.593v27.883c.507.183 1.239.382 1.75.382.638 0 1.251.08 1.824-.051l.012-28.213h-3.586zm20.719 19.846c1.284-1.354 2.598-2.996 3.587-4.594V42.634h-3.587v22.635zM27.259 48.482l8.339-9.586 7.921 2.94 16.89-12.088 8.514 8.037 4.279-3.419-.64-1.366-3.662 2.891-8.32-7.754-17.161 12.258-7.969-3.093-8.885 10.017-5.558 1.302.005 1.28 6.247-1.419zm1.717 5.706H25.39v6.977c1 1.53 2.311 2.952 3.586 4.247V54.188zM60.055 38.25h-3.586v33.701c1.179-.423 2.486-.925 3.586-1.503V38.25z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgAdobeAnalytics);
